module.exports = __webpack_public_path__ + "img/web_journey.be198c70.jpg";